import get from 'lodash/get';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import useUser from '../../hooks/useUser';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import {useGetHighlightsQuery} from '../../redux/services/providerHighlightApi';

import AppDashboard from '../AppDashboard';
import ChooseProviderScreen from '../../components/patientSignup/ChooseProviderScreen';

const handleSubmit = ({navigate}) => ({providerId}) => {
  navigate(`/clients/appointments/new/${providerId}`);
};

const BrowseProvidersPage = props => {
  const user = useUser();
  const navigate = useNavigate();
  const [providerFilters, setProviderFilters] = useState({});
  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const highlightsQuery = useGetHighlightsQuery(null, {skip: false});
  const providersQuery = useGetProvidersQuery(
    {providerId: selectedProviderId},
    {skip: !selectedProviderId}
  );
  const providers = get(providersQuery, 'data', []);
  const selectedProvider = providers.find(p => p.id === selectedProviderId);
  const childProps = {
    providerFilters,
    selectedProviderId,
    setProviderFilters,
    selectedProvider,
    highlights: get(highlightsQuery, 'data', []),
    onSubmit: handleSubmit({navigate}),
    onSelectProviderId: ({providerId}) => setSelectedProviderId(providerId),
  };
  return (
    <AppDashboard
      title='Browse Providers'
      loading={!user || highlightsQuery.isLoading}
      showBackBtn={true}
    >
      <ChooseProviderScreen {...childProps} />
    </AppDashboard>
  );
};

export default BrowseProvidersPage;
